/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import PropTypes from 'prop-types';
import { gnoment } from 'shared-ui/gnoment';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import {
    Icon,
    FlexRow,
    FlexCol,
    Button,
    RequiredValidation,
    Box,
    Label,
} from 'sarsaparilla';
import { getClassName } from 'ui-permit/src/utils/utilsNew';
import { IS_CHOICE_DATE_EMPTY } from 'ui-permit/src/constants';
import SingleDatePickerCalendar from '../single-date-picker-calendar';
import { dateSelectionProps } from '../../props/DateSelection';

export default class PreferredDatesItem extends React.Component {
    static propTypes = {
        selection: dateSelectionProps.isRequired,
        onChange: PropTypes.func.isRequired,
        onRemove: PropTypes.func.isRequired,
        index: PropTypes.number.isRequired,
        seasonStart: PropTypes.string,
        seasonEnd: PropTypes.string,
        validationErrors: PropTypes.shape({
            choiceRequired: PropTypes.string,
        }),
        pActions: PropTypes.shape({
            updatePendingReservation: PropTypes.func.isRequired,
            formValidationChange: PropTypes.func.isRequired,
        }).isRequired,
        validation: PropTypes.object.isRequired,
        onValidated: PropTypes.func,
        displayValidationError: PropTypes.bool,
    };

    handleChange = (valuePair) => {
        this.props.onChange({ ...this.props.selection, ...valuePair });
    };

    render() {
        const {
            index,
            availability,
            reservation,
            seasonStart,
            seasonEnd,
            validation,
            displayValidationError,
        } = this.props;

        let selectedDate;
        if (!isEmpty(this.props.selection.preferred_date)) {
            selectedDate = gnoment(this.props.selection.preferred_date);
        }
        const displayDate = selectedDate || gnoment(seasonStart);

        const validationHighlight = getClassName(
            get(validation, `${reservation.id}_${IS_CHOICE_DATE_EMPTY}_${index}`),
            displayValidationError
        );
        const choiceValidation = !isEmpty(selectedDate) ? 'true' : '';

        return (
            <Box background="gray-1" padding="md" className="per-form-group-item">
                <FlexRow justifyContent="space-between">
                    <FlexCol xs={6}>
                        <Label htmlFor={`dateSelect-${index}`} isRequired>
                            Choice #{index + 1}
                        </Label>
                    </FlexCol>
                    <FlexCol xs="variable">
                        <Button
                            id={`removeIcon-${index}`}
                            appearance="subtle-danger"
                            iconBeforeElement={<Icon iconName="delete" />}
                            onClick={() => this.props.onRemove(this.props.index)}
                            screenReaderTextBefore={`Remove choice ${this.props.index + 1} from the lottery preference list`}
                        />
                    </FlexCol>
                    <FlexCol xs={12}>
                        <div className={validationHighlight}>
                            <SingleDatePickerCalendar
                                currentDate={gnoment()}
                                id={`dateSelect-${index}`}
                                selectedDate={selectedDate}
                                seasonStart={seasonStart}
                                seasonEnd={seasonEnd}
                                handleDateChange={(value) =>
                                    this.handleChange({ preferred_date: value })
                                }
                                initialVisibleMonth={displayDate}
                                renderLabels={false}
                                availability={availability}
                                label={`Choice #${index + 1}`}
                                isInvalid={!!validationHighlight}
                            />
                            <RequiredValidation
                                value={choiceValidation}
                                displayInSummary
                                onValidated={this.props.onValidated(index)}
                                controlLabel={`Choice #${index + 1} A Valid date`}
                            />
                        </div>
                    </FlexCol>
                </FlexRow>
            </Box>
        );
    }
}
